// providerConstants — Registry der provider-spezifischen Karten-ENUM-Tags (Google) an EINER Stelle.
//
// Karten-Konstanten sind PROVIDER-spezifisch (Google hat andere Tags als z.B. Leaflet/MapLibre). Damit topoMapCore nicht
// überall `google.maps.ControlPosition[...]` / `google.maps.MapTypeId.*` streut, kapseln wir die Tags HIER.
//
// VORERST roh: unser Key IST der Google-Tag (Positionen 1:1; Map-Typen neutral-lowercase → Google). Genau dieses Modul ist
// der spätere Verlinkungspunkt: eigene neutrale Keys (links) → Provider-Tag (rechts) pro Provider; der Tausch von
// Legacy-Google-Konstanten auf aktuelle passiert ausschließlich hier.
//
// Capability-Prinzip (Zukunft): fehlt ein Tag bei einem Provider (z.B. kein ROADMAP), gibt es den zugehörigen Button nicht
// — wie `contexts` im Map-UI-Katalog, nur für Provider-Fähigkeiten. (Noch kein Consumer: es gibt keinen Map-Type-Switcher in der neuen UI.)
//
// NICHT hier (= eigenes Großthema „Provider-Abstraktion / Wrapper-Layer"): Klassen/API — LatLng, LatLngBounds, Point, Size,
// OverlayView, GroundOverlay, ImageMapType, Circle, Polygon, event.addListener … = Konstruktoren/Methoden, keine Konstanten.

// --- Control-Positionen ---  (unser Key == Google-Tag, 1:1)
export const CONTROL_POSITIONS = {
    LEFT_BOTTOM:   'LEFT_BOTTOM',     // Tools-Menü (links unten)
    BOTTOM_CENTER: 'BOTTOM_CENTER',   // Galerie-Navigation (unten zentriert)
    TOP_RIGHT:     'TOP_RIGHT',       // OV-Panel-Button
    TOP_LEFT:      'TOP_LEFT',        // Karte/Satellit-Umschalter (mapType)
    RIGHT_BOTTOM:  'RIGHT_BOTTOM'     // Zoom-Buttons
};

export function resolveControlPosition(google, key) {
    const tag = CONTROL_POSITIONS[key] || key;   // unbekannter Key → roh durchreichen (faithful)
    if (!google || !google.maps || !google.maps.ControlPosition) { return undefined; }
    return google.maps.ControlPosition[tag];
}

// --- Map-Typen (Basemap) ---  (neutrale lowercase Keys → Google-MapTypeId-Tag)
export const MAP_TYPES = {
    roadmap:   'ROADMAP',
    satellite: 'SATELLITE',
    terrain:   'TERRAIN',
    hybrid:    'HYBRID'
};

export function resolveMapType(google, key) {
    const tag = MAP_TYPES[key] || key;   // erlaubt neutralen Key ODER bereits einen Google-Tag
    if (!google || !google.maps || !google.maps.MapTypeId) { return undefined; }
    return google.maps.MapTypeId[tag];
}
